/* PA Card — mobile swipe + (+) sizes overlay */
(function () {
  function paCardDebug(step, extra) {
    console.log('[DLM Upcart Debug]', step, Object.assign({
      source: 'component-pa-card',
      href: window.location.href,
      shopifyRoot: window.Shopify?.routes?.root,
      bodyClass: document.body?.className,
      upcartOpenCartType: typeof window.upcartOpenCart,
      hasUpcartSettings: Boolean(window.upcartSettings),
      upcartCartIsEnabled: window.upcartSettings?.upcartEditorSettings?.cartIsEnabled,
      hasPompeiiOpenUpcart: typeof window.pompeiiOpenUpcart === 'function',
      hasThemeDrawer: Boolean(document.querySelector('cart-drawer')),
    }, extra || {}));
  }

  paCardDebug('script:start');

  function getCartRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return `${normalizedRoot}${String(path || '').replace(/^\/+/, '')}`;
  }

  function openCart() {
    paCardDebug('openCart:start');

    if (typeof window.pompeiiOpenUpcart === 'function') {
      paCardDebug('openCart:using-pompeiiOpenUpcart');
      window.pompeiiOpenUpcart();
      return;
    }

    if (typeof window.upcartOpenCart === 'function' && window.upcartSettings?.upcartEditorSettings?.cartIsEnabled !== false) {
      paCardDebug('openCart:using-window-upcartOpenCart');
      document.body.classList.remove('cart-drawer-open');
      window.upcartOpenCart();
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      paCardDebug('openCart:using-theme-drawer');
      drawer.open();
      return;
    }

    paCardDebug('openCart:no-opener-found');
  }

  function setupCard(card) {
    if (card.__paCardInit) return;
    card.__paCardInit = true;

    const slider = card.querySelector('[data-card-slider]');
    const track = card.querySelector('[data-card-track]');
    const dots = card.querySelectorAll('[data-card-dots] [data-dot]');
    const cartBtn = card.querySelector('[data-card-cart]');
    const overlay = card.querySelector('[data-card-sizes-overlay]');
    const link = card.querySelector('[data-card-link]');

    function setSizesOpen(open) {
      if (open) {
        card.setAttribute('data-sizes-open', '');
        if (cartBtn && cartBtn.hasAttribute('data-open-sizes')) cartBtn.setAttribute('aria-expanded', 'true');
        if (overlay) overlay.setAttribute('aria-hidden', 'false');
      } else {
        card.removeAttribute('data-sizes-open');
        if (cartBtn && cartBtn.hasAttribute('data-open-sizes')) cartBtn.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.setAttribute('aria-hidden', 'true');
      }
    }

    /* Update dots while scrolling track */
    if (track && dots.length) {
      const realSlides = track.querySelectorAll('.pa-card__slide');
      const numReal = realSlides.length;

      /* Infinite loop: clone the first slide at the end so scrolling past
         the last wraps back to the first silently. */
      let cloneSlide = null;
      if (numReal > 1) {
        cloneSlide = realSlides[0].cloneNode(true);
        cloneSlide.classList.add('pa-card__slide--clone');
        cloneSlide.removeAttribute('data-slide');
        cloneSlide.setAttribute('aria-hidden', 'true');
        track.appendChild(cloneSlide);
      }

      let raf;
      let resetTimer;
      track.addEventListener('scroll', () => {
        if (!raf) {
          raf = requestAnimationFrame(() => {
            let idx = Math.round(track.scrollLeft / track.clientWidth);
            if (cloneSlide && idx >= numReal) idx = 0;
            dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
            /* Past the first image: hide the desktop hover-swap overlay */
            card.classList.toggle('pa-card--browsing', idx !== 0);
            raf = null;
          });
        }
        if (cloneSlide) {
          clearTimeout(resetTimer);
          resetTimer = setTimeout(() => {
            const slideWidth = track.clientWidth;
            if (track.scrollLeft >= slideWidth * numReal - 2) {
              const prev = track.style.scrollBehavior;
              track.style.scrollBehavior = 'auto';
              track.scrollLeft = 0;
              /* Force a reflow before restoring smooth behavior */
              void track.offsetWidth;
              track.style.scrollBehavior = prev || '';
            }
          }, 80);
        }
      }, { passive: true });

      /* On desktop, leaving the card resets the carousel to the first image
         so the next hover shows the second-image swap again. */
      card.addEventListener('mouseleave', () => {
        if (!window.matchMedia('(hover: hover) and (min-width: 750px)').matches) return;
        if (track.scrollLeft === 0) return;
        track.scrollTo({ left: 0, behavior: 'auto' });
        card.classList.remove('pa-card--browsing');
      });

      /* Click a dot to jump to that slide (block link navigation) */
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(dot.dataset.dot, 10);
          if (isNaN(idx)) return;
          const slideWidth = track.clientWidth;
          track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
        });
      });
    }

    /* Inyectar flechas prev/next sutiles sobre la imagen (sólo si hay >1 imagen) */
    if (track) {
      const allSlides = track.querySelectorAll('.pa-card__slide:not(.pa-card__slide--clone)');
      const media = card.querySelector('.pa-card__media');
      if (media && allSlides.length > 1 && !card.__paImgArrows) {
        card.__paImgArrows = true;
        card.classList.add('pa-card--image-carousel');
        const mkArrow = (dir, label, path) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'pa-card__img-arrow pa-card__img-arrow--' + dir;
          b.setAttribute('aria-label', label);
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + path + '"/></svg>';
          return b;
        };
        const prevArrow = mkArrow('prev', 'Imagen anterior', '15 18 9 12 15 6');
        const nextArrow = mkArrow('next', 'Imagen siguiente', '9 6 15 12 9 18');
        const total = allSlides.length;
        const goImg = (delta) => {
          const w = track.clientWidth;
          if (!w) return;
          const current = Math.round(track.scrollLeft / w);
          let target = current + delta;
          if (target < 0) target = total - 1;
          if (target >= total) target = 0;
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        };
        const stopEvt = (e) => { e.preventDefault(); e.stopPropagation(); };
        prevArrow.addEventListener('click', e => { stopEvt(e); goImg(-1); });
        nextArrow.addEventListener('click', e => { stopEvt(e); goImg(+1); });
        media.appendChild(prevArrow);
        media.appendChild(nextArrow);
      }
    }

    /* Cart button: add directly, open the sizes overlay, or go to the product. */
    if (cartBtn) {
      cartBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        /* Product with sizes → toggle the overlay so the user picks a size */
        if (cartBtn.hasAttribute('data-open-sizes')) {
          setSizesOpen(!card.hasAttribute('data-sizes-open'));
          return;
        }

        /* Multi-variant (non-size) → send to the product page */
        const url = cartBtn.dataset.productUrl;
        if (url) {
          window.location.href = url;
          return;
        }

        /* Single variant → add to cart directly */
        const id = cartBtn.dataset.variantId;
        if (!id || cartBtn.classList.contains('is-loading')) return;
        paCardDebug('cartButton:start', { variantId: id });
        cartBtn.classList.add('is-loading');
        cartBtn.disabled = true;
        try {
          const res = await fetch(getCartRoute('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
          });
          paCardDebug('cartButton:response', { ok: res.ok, status: res.status });
          if (!res.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const drawer = document.querySelector('cart-drawer');
          if (typeof window.pompeiiOpenUpcart === 'function' || (typeof window.upcartOpenCart === 'function' && window.upcartSettings?.upcartEditorSettings?.cartIsEnabled !== false)) {
            openCart();
          } else if (drawer) {
            if (typeof drawer.refresh === 'function') await drawer.refresh();
            openCart();
          } else {
            window.location.href = getCartRoute('cart');
          }
        } catch (err) {
          paCardDebug('cartButton:error', { error: String(err) });
          console.error('Add to cart failed', err);
        } finally {
          cartBtn.classList.remove('is-loading');
          cartBtn.disabled = false;
        }
      });
    }

    /* Tap outside the overlay (still inside the card) closes it */
    if (overlay) {
      card.addEventListener('click', (e) => {
        if (!card.hasAttribute('data-sizes-open')) return;
        if (e.target.closest('[data-card-cart]')) return;
        if (e.target.closest('.pa-card__size')) return;
        if (e.target.closest('[data-card-sizes-overlay]') && !e.target.closest('.pa-card__sizes-grid')) {
          e.preventDefault();
          e.stopPropagation();
          setSizesOpen(false);
        }
      });
    }

    /* Block link navigation when overlay is open */
    if (link) {
      link.addEventListener('click', (e) => {
        if (card.hasAttribute('data-sizes-open')) {
          e.preventDefault();
        }
      });
    }

    /* Quick-buy: clicking a size button adds variant to cart and opens drawer */
    card.querySelectorAll('[data-quick-buy]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        const id = btn.dataset.variantId;
        if (!id) return;
        paCardDebug('quickBuy:start', { variantId: id });
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = '...';
        try {
          const res = await fetch(getCartRoute('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
          });
          paCardDebug('quickBuy:response', { ok: res.ok, status: res.status, statusText: res.statusText });
          if (!res.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          /* Close overlay */
          setSizesOpen(false);
          /* Refresh + open cart drawer */
          const drawer = document.querySelector('cart-drawer');
          if (typeof window.pompeiiOpenUpcart === 'function' || (typeof window.upcartOpenCart === 'function' && window.upcartSettings?.upcartEditorSettings?.cartIsEnabled !== false)) {
            paCardDebug('quickBuy:opening-upcart');
            openCart();
          } else if (drawer) {
            paCardDebug('quickBuy:opening-theme-drawer');
            if (typeof drawer.refresh === 'function') await drawer.refresh();
            openCart();
          } else {
            paCardDebug('quickBuy:fallback-to-cart-page');
            window.location.href = getCartRoute('cart');
          }
        } catch (err) {
          paCardDebug('quickBuy:error', { error: String(err), stack: err?.stack });
          console.error('Quick-buy failed', err);
        } finally {
          btn.disabled = false;
          btn.textContent = original;
        }
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-card]').forEach(setupCard);
  }

  window.shopifyReinitCards = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
